<app-custom-table
  titleMultipleResults="Gutscheine"
  titleSingleResult="Gutschein"
  [dataSource$]="dataSource$"
  [columns]="columns"
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="50"
  [fuzzySearch]="true"
  [filters]="filters"
  noDataIcon="fa-ticket"
  noDataMessage="Es gibt derzeit keine Gutscheine."
  noSearchResultsIcon="fa-ticket"
  noSearchResultsMessage="Es gibt keine Gutscheine, die mit deinen Suchkriterien übereinstimmen."
  [dataSource$]="dataSource$"
  [isLoading]="isLoading"></app-custom-table>
